'use strict';

/**
 * Product properties (blocks/product-properties.liquid).
 * - A tile or «Vis alle egenskaper» opens the panel (a native modal <dialog>: focus is trapped, Esc closes). A tile
 *   scrolls to and highlights its own entry in the panel.
 * - The X, a click on the dimmed area and Esc close it; focus returns to the button that opened it.
 * - The documentation link follows the variant picker (event pippei:variant-change).
 */
(function () {
  function init(root) {
    if (root.__pqReady) return;
    root.__pqReady = true;
    var dialog = root.querySelector('[data-pq-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var opener = null;

    function open(target, from) {
      opener = from;
      dialog.showModal();
      document.documentElement.classList.add('pq-lock');
      [].slice.call(dialog.querySelectorAll('.pq-item.is-target')).forEach(function (n) { n.classList.remove('is-target'); });
      var item = target === 'all' ? null : dialog.querySelector('[data-pq-item="' + target + '"]');
      var body = dialog.querySelector('.pq-panel__body');
      if (item) {
        item.classList.add('is-target');
        item.scrollIntoView({ block: 'center' });
        item.focus({ preventScroll: true });
      } else if (body) {
        body.scrollTop = 0;
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pq-open]');
      if (btn && root.contains(btn)) { open(btn.getAttribute('data-pq-open'), btn); return; }
      if (e.target.closest('[data-pq-close]')) { dialog.close(); return; }
      // A click on the dimmed area (the dialog element itself, outside the panel).
      if (e.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('pq-lock');
      if (opener && opener.focus) opener.focus();
      opener = null;
    });

    document.addEventListener('pippei:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      var docs = [].slice.call(root.querySelectorAll('[data-pq-doc]'));
      if (!docs.length) return;
      var any = docs.some(function (a) { return a.getAttribute('data-pq-doc') === String(v.id); });
      docs.forEach(function (a) { a.hidden = any ? a.getAttribute('data-pq-doc') !== String(v.id) : true; });
    });
  }

  function run() { [].slice.call(document.querySelectorAll('[data-pq]')).forEach(init); }
  run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', run);
})();
